//@flow
import React, { PureComponent } from 'react'
import { Route, withRouter, Redirect, Switch } from 'react-router-dom'

import ApiTest from './apiTest'
import Main from './main'
import Manipulater from './manipulater'
import './styles.css'


class App extends PureComponent {

  render = () => {
    return(
      <fb className="appMain">
        <Switch>
          <Route path='/app/main/:coinID' component={Main} />
          <Route path='/app/main' component={Main} />
          <Route path='/app/manipulate22' component={Manipulater} />
          <Route path='/app/apitest' component={ApiTest} />
          <Redirect to='/app/main'/>
        </Switch>
      </fb>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/containers/app/index.js